<template>
  <v-container class="d-flex flex-column">
    <v-layout row wrap class="fill-height">

      <v-flex xs4 offset-xs4 class="text-center">
        <div class="text-xs-center pa-2">
          <div v-if="!outOfTime">
            <p class="headline">Configuring Text Messaging</p>
            <p class="subheading">This should only take a few moments.</p>
          </div>
          <span v-else class="headline">Uh oh!</span>
        </div>
      </v-flex>

      <v-flex xs6 offset-xs3>
        <v-progress-linear v-model="value" :color="progressColor" :indeterminate="!outOfTime" rounded height="15"></v-progress-linear>
      </v-flex>

      <v-flex v-if="outOfTime" xs4 offset-xs4 class="text-center">
        <div class="text-xs-center pa-2">
          <span class="subheading">It appears it is taking longer than expected to configure your agency.</span>
        </div>
        <div class="text-xs-center pa-2">
          <span class="subheading">Please try again later or contact inside sales at 866-884-4680, Option 3 or Email <a href="mailto:support@hawksoft.com">support@hawksoft.com</a></span>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'TextingSetupConf',
  data: () => ({
    confTask: null,
    maxWaitTime: 30000,
    totalWaitTime: 0,
    interval: 3000,
    errorColor: 'red accent-4',
    startColor: 'blue darken-2',
    value: 100,
    orderStatus: 0
  }),
  computed: {
    ...mapState(['agency']),
    outOfTime () {
      return this.maxWaitTime <= this.totalWaitTime;
    },
    progressColor () {
      return this.outOfTime ? this.errorColor : this.startColor;
    }
  },
  created () {
    this.confTask = setInterval(this.getAgency, this.interval);
  },
  methods: {
    async getAgency () {
      if (this.outOfTime) {
        clearInterval(this.confTask);
        return;
      }

      this.totalWaitTime += this.interval;
      try {
        const response = await this.$api.getAgency(this.agency.agencyId);
        if (response.data) {
          if (response.data.code === 2) {
            this.routeAway('TextingSetup');
          } else if (response.data.code === 3) {
            // Do nothing...
          } else if (response.data.code === 0) {
            if ((response.data.data[0] || null) !== null) {
              await this.fetchOrderInfo();
            } else {
              this.routeAway('TextingSetup');
            }
          } else {
            this.routeAway('Error');
          }
        }
      } catch (err) {
        this.routeAway('Error');
      }
    },
    async fetchOrderInfo () {
      const response = await this.$api.getOrderInfo();
      if (response.data) {
        if (response.data.code === 0) {
          this.orderStatus = response.data.data[0].status;
        }
        this.routeAway('TextingSetupMod');
      }
    },
    routeAway (name) {
      clearInterval(this.confTask);
      this.$router.push({ name });
    }
  }
};
</script>

<style scoped lang="scss">
  .header {
    background-color: #145392;
    color: #FFF;
    padding: 5px;
  }

  h1 {
    margin: 0;
  }
</style>
